import {FiltersMenu} from '~molecules/FiltersMenu';
import {DesktopWalletMenu} from '~molecules/DesktopWalletMenu';
import useFetchFilteredPlotsIds from '~api/useFetchFilteredPlotsIds';
import {useFilters} from '~providers/FiltersProvider';
import {ApiEndpoints} from '~constants/api';
import MapListSwitch from '~components/molecules/MapListSwitch';

import MarsMap from '../MarsMap';

export type MapPageProps = {
    filteredPlotsEndpoint: ApiEndpoints;
    withWallet?: boolean;
    pageTitle?: string;
};

const MapPage = ({
    filteredPlotsEndpoint,
    pageTitle,
    withWallet = false,
}: MapPageProps) => {
    const {filters, mapFiltersWhitelist} = useFilters();

    const {data: filteredPlots, isFetching: isFilteredLoading} =
        useFetchFilteredPlotsIds(
            filteredPlotsEndpoint,
            withWallet,
            filters,
            mapFiltersWhitelist,
        );

    return (
        <>
            <MarsMap filteredPlots={filteredPlots} isLoading={isFilteredLoading} />
            <FiltersMenu openBtnStyle="white" pageTitle={pageTitle} />
            <DesktopWalletMenu color="white" />
            <MapListSwitch absolute color="white" />
        </>
    );
};

export default MapPage;
